import type { CountryCode } from 'libphonenumber-js'
import { getCountries } from 'libphonenumber-js'

export interface Country {
  code: CountryCode
  name: string
}

export const DEFAULT_COUNTRY: CountryCode = 'GB'

// English names on purpose: they end up in Pabau as the mailing country, so they
// must stay consistent regardless of the locale the form was filled in.
const displayNames = new Intl.DisplayNames(['en'], { type: 'region' })

// Alphabetical, with the default country pinned at the top.
export const COUNTRIES: Country[] = getCountries()
  .map(code => ({ code, name: displayNames.of(code) ?? code }))
  .sort((a, b) =>
    Number(b.code === DEFAULT_COUNTRY) - Number(a.code === DEFAULT_COUNTRY)
    || a.name.localeCompare(b.name, 'en'))

export const DEFAULT_COUNTRY_NAME = COUNTRIES.find(c => c.code === DEFAULT_COUNTRY)!.name

export function countryCodeFromName(name: string | undefined): CountryCode | undefined {
  return COUNTRIES.find(c => c.name === name)?.code
}
